import { render, staticRenderFns } from "./ChinaCity.vue?vue&type=template&id=77d16a10&scoped=true"
import script from "./ChinaCity.vue?vue&type=script&lang=js"
export * from "./ChinaCity.vue?vue&type=script&lang=js"
import style0 from "./ChinaCity.vue?vue&type=style&index=0&id=77d16a10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d16a10",
  null
  
)

export default component.exports